import { ChevronRight, Home } from 'lucide-react';
import { ViewType } from '../../types';

interface BreadcrumbsProps {
  currentView: ViewType;
  onNavigate: (view: ViewType) => void;
}

const viewLabels: Record<ViewType, string> = {
  dashboard: '主控制板',
  login: '登入',
  register: '註冊',
  expenses: '支出紀錄',
  settlements: '結算中心',
  accounts: '帳戶管理',
  members: '成員概覽',
  'add-expense': '新增支出',
  'edit-expense': '修改支出',
  search: '搜尋結果',
  history: '查詢交易歷史',
  'system-admin': '系統管理',
};

export function Breadcrumbs({ currentView, onNavigate }: BreadcrumbsProps) {
  return (
    <nav className="flex items-center space-x-2 text-sm font-medium text-muted-foreground mb-6" aria-label="Breadcrumb">
      <button 
        onClick={() => onNavigate('dashboard')}
        className="flex items-center hover:text-primary transition-colors gap-1"
      >
        <Home size={14} />
        <span>首頁</span>
      </button>
      
      {currentView !== 'dashboard' && (
        <>
          <ChevronRight size={14} className="opacity-40" />
          <span className="text-foreground font-bold tracking-tight">
            {viewLabels[currentView]}
          </span>
        </>
      )}
    </nav>
  );
}
